module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp1_1.1599dc50.png";